var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-invert reverse-sm",
      attrs: { id: "healthmentalcare" }
    },
    [
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("carementalhealth.title")))]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("div", { staticClass: "subtitle-list subtitle-list mt-sm-5" }, [
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-meditation") }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("carementalhealth.yoga")) + "\n            "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  { staticStyle: { fontSize: "1rem", "margin-left": "5rem" } },
                  [_vm._v(_vm._s(_vm.$t("carementalhealth.yogatext")))]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-spa") }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("carementalhealth.mindfulness")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  { staticStyle: { fontSize: "1rem", "margin-left": "5rem" } },
                  [_vm._v(_vm._s(_vm.$t("carementalhealth.mindfulnesstext")))]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-brightness-2") }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("carementalhealth.dream")) + "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  { staticStyle: { fontSize: "1rem", "margin-left": "5rem" } },
                  [_vm._v(_vm._s(_vm.$t("carementalhealth.dreamtext")))]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-yoga") }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("carementalhealth.pilates")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  { staticStyle: { fontSize: "1rem", "margin-left": "5rem" } },
                  [_vm._v(_vm._s(_vm.$t("carementalhealth.pilatestext")))]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { md: "12", lg: "6" } }, [
        _c("div", { staticClass: "col-bg ml-lg-auto" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f21a9ac8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f21a9ac8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/CareMentalHealth.vue
// module id = 4180
// module chunks = 36